"use strict";

exports.__esModule = true;
exports.DeviceTableFields = DeviceTableFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DeviceTableElement.
 */
function DeviceTableFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceTable.rowHeight.label", "Row Height"),
      helperText: translate("DeviceTable.rowHeight.helperText", "The height of each row in the table.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 32,
      max: 256,
      value: element.props.itemHeight || 64,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "itemHeight", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceTable.rowGutter.label", "Row Gutter Size"),
      helperText: translate("DeviceTable.rowGutter.helperText", "The size of the gap between rows in the table.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.rowGutter || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "rowGutter", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementActionControlGroup, {
      controlPaths: {
        onClickAction: path
      },
      elementEditor: elementEditor
    }));
  });
}